import { computed as m, createElementBlock as r, openBlock as o, normalizeClass as c, createElementVNode as d, createVNode as g, withCtx as y, renderSlot as h, createCommentVNode as i, createBlock as u, toDisplayString as f } from "vue";
import { themeProp as w } from "../../composables/useTheme.js";
import k from "../../molecules/breadcrumbs/breadcrumbs.vue.js";
import p from "../../molecules/eyebrow/eyebrow.vue.js";
import x from "../../molecules/link-back/link-back.vue.js";
import v from "../../molecules/link/link.vue.js";
import b from "../../templates/media-layout/media-layout.vue.js";
/* empty css                    */
const D = { class: "ds-display-flex ds-flex-direction-column ds-justify-content-space-between ds-height-full" }, B = { key: 0 }, S = ["src", "alt"], z = { class: "ds-hero-with-form__content" }, $ = ["textContent"], A = {
  key: 0,
  class: "ds-rich-text ds-text-medium"
}, C = {
  key: 1,
  class: "ds-buttons-wrapper ds-margin-top-24"
}, E = { class: "ds-position-relative ds-hero-with-form__form" }, j = ["grey", "green", "blue", "yellow", "orange", "red", "purple", "grey-350", "grey-1900", "grey-2500"], F = /* @__PURE__ */ Object.assign({
  name: "DsHeroWithForm"
}, {
  __name: "hero-with-form",
  props: {
    ...w,
    description: {
      type: String,
      default: ""
    },
    logo: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      required: !0
    },
    icon: {
      type: Object,
      default: null
    },
    eyebrow: {
      type: String,
      default: ""
    },
    navigationData: {
      type: [Object, Array],
      default: null,
      validator: (t) => Array.isArray(t) ? t.every((n, l, a) => l === a.length - 1 ? "title" in n : ["title", "url"].every((s) => s in n)) : ["text", "url"].every((n) => n in t)
    },
    links: {
      type: Array,
      required: !0
    },
    withSpaceBottom: {
      type: Boolean,
      default: !0
    },
    withSpaceTop: {
      type: Boolean,
      default: !0
    },
    withBoldTag: {
      type: Boolean,
      default: !1
    },
    smallLogo: {
      type: Boolean,
      default: !1
    },
    eyebrowColor: {
      type: String,
      default: "grey",
      validator: (t) => !t || j.includes(t)
    },
    yAlign: {
      type: String,
      default: "flex-end",
      validator: (t) => ["center", "stretch", "flex-end", "none"].includes(t)
    }
  },
  setup(t) {
    const n = t, l = m(() => {
      var e;
      return !((e = n.links) != null && e.length) > 0 ? null : n.links[0];
    }), a = m(() => {
      var e;
      return !((e = n.links) != null && e.length) > 1 ? null : n.links[1];
    }), s = m(() => Array.isArray(n.navigationData));
    return (e, L) => (o(), r("section", {
      class: c(["ds-hero-with-form", `ds-hero-with-form--${e.theme}`])
    }, [
      d("div", {
        class: c(["ds-container", [
          {
            "ds-padding-top-48 ds-md-padding-top-72": t.withSpaceTop,
            "ds-padding-bottom-48 ds-md-padding-bottom-96": t.withSpaceBottom
          }
        ]])
      }, [
        g(b, {
          "media-columns-width": { small: 12, medium: 6, large: 5 },
          "content-columns-width": { small: 12, medium: 6, large: 5 },
          "y-align": t.yAlign
        }, {
          content: y(() => [
            d("div", D, [
              t.logo || t.navigationData ? (o(), r("div", B, [
                t.logo ? (o(), r("img", {
                  key: 0,
                  class: c(["ds-hero-with-form__logo", { "ds-hero-with-form__logo--small": t.smallLogo }]),
                  src: t.logo.src,
                  alt: t.logo.name,
                  "data-j-logo": ""
                }, null, 10, S)) : i("", !0),
                t.navigationData && !s.value ? (o(), u(x, {
                  key: 1,
                  theme: e.theme,
                  "tracking-data": { "component-name": e.$options.name, text: t.navigationData.text, title: t.title },
                  text: t.navigationData.text,
                  url: t.navigationData.url,
                  nuxt: t.navigationData.nuxt,
                  "lazy-url-endpoint": t.navigationData.lazyUrlEndpoint
                }, null, 8, ["theme", "tracking-data", "text", "url", "nuxt", "lazy-url-endpoint"])) : t.navigationData ? (o(), u(k, {
                  key: 2,
                  theme: e.theme,
                  crumbs: t.navigationData,
                  "tracking-data": { "component-name": e.$options.name, title: t.title }
                }, null, 8, ["theme", "crumbs", "tracking-data"])) : i("", !0)
              ])) : i("", !0),
              d("div", z, [
                t.eyebrow ? (o(), u(p, {
                  key: 0,
                  text: t.eyebrow,
                  theme: e.theme
                }, null, 8, ["text", "theme"])) : i("", !0),
                d("h1", {
                  class: "ds-margin-bottom-12 ds-heading-large",
                  textContent: f(t.title)
                }, null, 8, $),
                h(e.$slots, "description", {}, () => [
                  t.description ? (o(), r("div", A, f(t.description), 1)) : i("", !0)
                ]),
                l.value || a.value ? (o(), r("div", C, [
                  g(v, {
                    url: l.value.url,
                    "lazy-url-endpoint": l.value.lazyUrlEndpoint,
                    "open-in-new-window": l.value.openInNewWindow,
                    nuxt: l.value.nuxt,
                    content: l.value.title,
                    "tracking-data": { "component-name": e.$options.name, text: l.value.title, title: t.title },
                    color: "black"
                  }, null, 8, ["url", "lazy-url-endpoint", "open-in-new-window", "nuxt", "content", "tracking-data"]),
                  a.value ? (o(), u(v, {
                    key: 0,
                    url: a.value.url,
                    "lazy-url-endpoint": a.value.lazyUrlEndpoint,
                    "open-in-new-window": a.value.openInNewWindow,
                    nuxt: a.value.nuxt,
                    content: a.value.title,
                    "icon-right": { category: "arrows", name: "chevron-right-small" },
                    "tracking-data": { "component-name": e.$options.name, text: a.value.title, title: t.title },
                    variant: "secondary",
                    color: "green",
                    class: "ds-md-margin-left-24"
                  }, null, 8, ["url", "lazy-url-endpoint", "open-in-new-window", "nuxt", "content", "tracking-data"])) : i("", !0)
                ])) : i("", !0)
              ])
            ])
          ]),
          media: y(() => [
            d("div", E, [
              h(e.$slots, "form")
            ])
          ]),
          _: 3
        }, 8, ["y-align"])
      ], 2)
    ], 2));
  }
});
export {
  F as default
};
